
import InfiniteMarquee from '../InfiniteMarquee/InfiniteMarquee';
import ExclusiveServices from '../ExclusiveServices/ExclusiveServices'
import FeaturedProjects from '../FeatureProjects/FeatureProjects';
import ExperienceSection from '../ExperienceSection/ExperienceSection';

const HomePortfolioSection = ()=>(
      <div className='home'>
        <ExclusiveServices />
        <FeaturedProjects/>
        <InfiniteMarquee />
        <ExperienceSection/>
      </div>  
    )

export default HomePortfolioSection;
